import React from 'react';
import Icon from './Icon';

interface NavBarProps {
  title?: string;
  onBack?: () => void;
  backLabel?: string;
  right?: React.ReactNode;
}

const NavBar: React.FC<NavBarProps> = ({ title, onBack, backLabel = 'Zurück', right }) => (
  <header className="nav-bar">
    <div className="nav-left">
      {onBack && (
        <button className="nav-btn" onClick={onBack} aria-label="Zurück">
          <Icon name="chevron-left" size={22} />
          <span style={{ marginLeft: 2 }}>{backLabel}</span>
        </button>
      )}
    </div>
    <div className="nav-title">{title || ''}</div>
    <div className="nav-right">{right}</div>
  </header>
);

export default NavBar;
